// components/KenoRightSidebar.jsx
import React, { useState, useEffect, useRef } from "react";
import "./KenoGame.css";
import { api, socket } from "../../api";
import { parseJWT } from "../../utils/jwtUtils";

const KenoRightSidebar = ({
  betPerBall,
  setBetPerBall,
  increaseBet,
  decreaseBet,
  doubleBet,
  maxBet,
  placeBet,
  drawnNumbers,
}) => {
  const [kenoResults, setKenoResults] = useState([]);
  const [statistics, setStatistics] = useState([]);
  const [myHistory, setMyHistory] = useState([]);
  const [allBets, setAllBets] = useState([]);
  const [rightTab, setRightTab] = useState("results");
  const [totalPlayers, setTotalPlayers] = useState(0);

  const token = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null;

  const userInfo = parseJWT(token?.token);

  const userId = userInfo?.id;
  const phone = userInfo?.phone;

  useEffect(() => {
    if (userId) {
      socket.emit("joinGame", {
        userId,
        phone,
      });
    }
    // =========================================
    // JOINED
    // =========================================
    socket.on("joined", (data) => {
      // =====================================
      // CURRENT ROUND
      // =====================================

      if (data.playerStats) {
        setTotalPlayers(Number(data.playerStats.totalPlayers || 0));
      }
      if (data.allBets) {
        setAllBets(data.allBets);
      }

      if (data.myHistory) {
        setMyHistory(data.myHistory);
      }
    });

    // =========================================
    // PLAYERS UPDATE
    // =========================================
    socket.on("playersUpdate", (data) => {
      setTotalPlayers(Number(data.totalPlayers || 0));
    });

    // =========================================
    // PLAYER BET EVENT
    // =========================================
    socket.on("playerBet", (data) => {});

    // LIVE RESULTS UPDATE
    // =========================================
    socket.on("resultsUpdate", (data) => {
      //  console.log("RESULTS UPDATE:", data);

      setKenoResults(data || []);
    });

    // =========================================
    // LIVE STATISTICS UPDATE
    // =========================================
    socket.on("statisticsUpdate", (data) => {
      // console.log("STATISTICS UPDATE:", data);

      setStatistics(data || []);
    });
    // =========================================
    // LIVE GAME BETS
    // =========================================
    socket.on("liveGameBets", (data) => {
      setAllBets(data || []);
    });

    // =========================================
    // MY HISTORY
    // =========================================
    socket.on("myHistoryUpdate", (data) => {
      setMyHistory(data || []);
    });

    //=======================================
    // BETS UPDATED
    // =========================================
    socket.on("betsUpdated", (data) => {});
    // =========================================
    // CLEANUP
    // =========================================
    return () => {
      socket.off("joined");

      socket.off("resultsUpdate");

      socket.off("statisticsUpdate");

      socket.off("playerBet");

      socket.off("betsUpdated");

      socket.off("liveGameBets");

      socket.off("myHistoryUpdate");

      socket.off("playersUpdate");
      socket.off("connect");

      socket.off("disconnect");
    };
  }, []);

  const myBets = allBets.filter((bet) => Number(bet.userId) === Number(userId));

  return (
    <div className="content_right_side">
      <div className="side_cont_path">
        {/* MOBILE BET */}
        <div className="bet_ui for_mobile_only">
          <div className="bet_input">
            <div className="bet_input_row">
              <div className="bet_input_top">
                <div className="bet_input_ui">
                  <span
                    onClick={decreaseBet}
                    className="bet_input_btn_m"
                    data-val="-1"
                  >
                    <img src="https://cdn-atlas-v.com/games/keno/img/mns.svg" />
                  </span>
                  <input
                    inputMode="numeric"
                    pattern="[0-9]*"
                    className="bet_input_bar"
                    id="bet_input_bar"
                    autoComplete="new-password"
                    type="number"
                    value={betPerBall}
                    onChange={(e) => setBetPerBall(Number(e.target.value))}
                  />
                  <span className="bet_input_btn_m" onClick={increaseBet}>
                    <img src="https://cdn-atlas-v.com/games/keno/img/pls.svg" />
                  </span>
                </div>
                <div className="bet_input_btn double_bet" onClick={doubleBet}>
                  <span>X2</span>
                </div>
                <div className="bet_input_btn" data-val="100" onClick={maxBet}>
                  <span>MAX</span>
                </div>
              </div>
            </div>
            <div className="bet_input_row">
              <div className="bet_set_btn active">
                <div
                  className="bet_set_btn_txt"
                  id="trs_place"
                  onClick={placeBet}
                >
                  BET
                </div>
                <div className="bet_set_btn_wait" id="trs_wait">
                  WAIT...
                </div>
                <div className="bet_set_btn_accept">
                  <img src="https://cdn-atlas-v.com/games/keno/img/check.svg" />{" "}
                  <span id="trs_accepted">BET ACCEPTED</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* STATISTICS UI */}
        <div className="statistic_ui">
          <div className="tab_content_wrapper">
            <div className="tabs right_side_tabs_top for_mobile_only">
              <div
                className={`tab_itm ${rightTab === "game" ? "active" : ""}`}
                id="tab1"
                onClick={() => setRightTab("game")}
              >
                GAME
              </div>
              <div
                className={`tab_itm ${rightTab === "history" ? "active" : ""}`}
                id="tab2"
                onClick={() => setRightTab("history")}
              >
                HISTORY
              </div>
              <div
                className={`tab_itm ${rightTab === "results" ? "active" : ""}`}
                id="tab3"
                onClick={() => setRightTab("results")}
              >
                RESULTS
              </div>
              <div
                className={`tab_itm ${rightTab === "statistics" ? "active" : ""}`}
                id="tab4"
                onClick={() => setRightTab("statistics")}
              >
                STATISTICS
              </div>
            </div>
            <div className="tabs right_side_tabs_top for_desktop_only">
              <div
                className={`tab_itm ${rightTab === "results" ? "active" : ""}`}
                id="tab3"
                onClick={() => setRightTab("results")}
              >
                RESULTS
              </div>
              <div
                className={`tab_itm ${rightTab === "statistics" ? "active" : ""}`}
                id="tab4"
                onClick={() => setRightTab("statistics")}
              >
                STATISTICS
              </div>
            </div>
            <div className="tab_conts right_side_tabs_cont">
              <div
                className={`tab_cont cont_tab1 ${
                  rightTab === "game" ? "active" : ""
                }`}
              >
                <div className="table_header">
                  <div className="table_header_itm active">
                    <span id="trs_bets">All</span>{" "}
                    <span className="total_tickets_count">{totalPlayers}</span>
                  </div>

                  <div className="table_header_itm">
                    <span id="trs_mytiks">My Tickets</span>{" "}
                    <span className="my_tickets_count">
                      {allBets.filter((bet) => bet.userId === userId).length}
                    </span>
                  </div>

                  <div className="table_header_itm">
                    <span id="trs_mybets">My Bets</span>{" "}
                    <span className="my_bets_count">
                      {allBets.filter((bet) => bet.userId === userId).length}
                    </span>
                  </div>
                </div>

                <div className="table_cont game_table">
                  {allBets
                    .filter((bet) => bet.userId === userId)
                    .map((bet, index) => {
                      let nums = bet.numbers || [];

                      if (typeof nums === "string") {
                        try {
                          nums = JSON.parse(nums);
                        } catch {
                          nums = [];
                        }
                      }

                      const filledNumbers = [...nums];

                      while (filledNumbers.length < 10) {
                        filledNumbers.push(null);
                      }

                      return (
                        <div
                          className="table_row other_tcket_itm"
                          key={index}
                          data-numbers={nums.join(",")}
                          data-bet={bet.betAmount}
                        >
                          <div className="table_row_ttl">
                            {index + 1}{" "}
                            {bet.userId === userId
                              ? "My Ticket"
                              : bet.user?.username || "Player"}
                          </div>

                          <div className="table_row_bet_nums">
                            {[...Array(10)].map((_, i) => {
                              const num = nums[i];

                              const isMatched = drawnNumbers.includes(
                                Number(num),
                              );

                              return (
                                <div
                                  key={i}
                                  className={`bet_nms ${
                                    num
                                      ? `bet_nms${num} ${isMatched ? "show" : ""}`
                                      : "inactive"
                                  }`}
                                >
                                  {num || ""}
                                </div>
                              );
                            })}
                          </div>

                          <div className="table_row_bet_status">
                            <div className="table_row_halff">
                              Bet {bet.betAmount}
                            </div>

                            <div className="table_row_halff game_status_wait">
                              {bet.status || "Waiting"}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
              <div
                className={`tab_cont cont_tab3 ${
                  rightTab === "results" ? "active" : ""
                }`}
              >
                <div className="table_header">
                  <div className="table_header_itm" id="trs_drawid">
                    Draw ID
                  </div>
                  <div
                    className="table_header_itm"
                    id="trs_combin2"
                    style={{
                      justifyContent: "flex-end",
                      paddingRight: "1em",
                    }}
                  >
                    Combination
                  </div>
                </div>
                <div className="table_cont game_history">
                  {kenoResults.map((row, index) => {
                    let nums = row.drawnNumbers || [];

                    if (typeof nums === "string") {
                      try {
                        nums = JSON.parse(nums);
                      } catch {
                        nums = [];
                      }
                    }

                    return (
                      <div className="table_row" key={index}>
                        <div className="table_row_itm fairness_icn">
                          {row.roundId}
                          <br />

                          {new Date(row.createdAt).toLocaleTimeString()}
                        </div>

                        <div className="table_row_itm game_result_icon">
                          {nums.map((num, i) => (
                            <span key={i} className="ben_his_itm">
                              {num}
                            </span>
                          ))}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div
                className={`tab_cont cont_tab2 ${
                  rightTab === "history" ? "active" : ""
                }`}
              >
                <div className="table_cont game_mybet_history_path">
                  <div className="game_mybet_history">
                    {myHistory
                      .filter((bet) => bet.userId === userId)
                      .map((bet, index) => {
                        let nums = bet.numbers || [];

                        if (typeof nums === "string") {
                          try {
                            nums = JSON.parse(nums);
                          } catch {
                            nums = [];
                          }
                        }
                        let matchedNumbers = bet.matchedNumbers || [];

                        if (typeof matchedNumbers === "string") {
                          try {
                            matchedNumbers = JSON.parse(matchedNumbers);
                          } catch {
                            matchedNumbers = [];
                          }
                        }
                        const filledNumbers = [...nums];

                        while (filledNumbers.length < 10) {
                          filledNumbers.push(null);
                        }

                        return (
                          <div className="tab_history_itm" key={index}>
                            <div className="tab_history_itm_top">
                              <div className="tab_history_itm_top_ttl">
                                <div className="tab_history_itm_top_ttl_line"></div>

                                <div className="tab_history_itm_top_ttl_dat">
                                  <div className="tab_history_itm_top_ttl_dat_wrap">
                                    Draw ID:&nbsp;
                                    {bet.roundId}
                                    <span>
                                      &nbsp;
                                      {new Date(bet.createdAt).toLocaleString()}
                                    </span>
                                  </div>
                                </div>

                                <div className="tab_history_itm_top_ttl_line"></div>
                              </div>
                            </div>

                            <div className="table_cont">
                              <div
                                className={`table_row ${
                                  bet.status === "win" || bet.status === "won"
                                    ? "winrow"
                                    : ""
                                }`}
                              >
                                <div className="table_row_bet_nums">
                                  {filledNumbers.map((num, i) => (
                                    <div
                                      key={i}
                                      className={`bet_nms ${
                                        !num
                                          ? "inactive"
                                          : matchedNumbers.includes(Number(num))
                                            ? "sell"
                                            : ""
                                      }`}
                                    >
                                      {num || ""}
                                    </div>
                                  ))}
                                </div>

                                <div className="table_row_bet_status">
                                  <div className="table_row_halff">
                                    Bet {Number(bet.betAmount).toFixed(2)}
                                  </div>

                                  {(bet.winAmount > 0 ||
                                    bet.status === "win" ||
                                    bet.status === "won") && (
                                    <div className="table_row_halff game_status_win">
                                      {bet.winAmount
                                        ? Number(bet.winAmount).toFixed(2)
                                        : "WIN"}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
              <div
                className={`tab_cont cont_tab4 ${
                  rightTab === "statistics" ? "active" : ""
                }`}
              >
                <div className="table_header">
                  <div className="table_header_itm" id="trs_stsh">
                    Last 100 rounds
                  </div>
                  <div className="table_header_itm sorting  sort1">
                    <span id="trs_sort">Sort</span>
                    <svg
                      fill="#fff"
                      className="sorting_icn sorting_icn1"
                      viewBox="0 0 24 24"
                    >
                      <g>
                        <rect
                          x="3"
                          y="11"
                          width="18"
                          height="2"
                          rx="1"
                          fill="#fff"
                        ></rect>
                        <rect
                          x="3"
                          y="16"
                          width="12"
                          height="2"
                          rx="1"
                          fill="#fff"
                        ></rect>
                        <rect
                          x="3"
                          y="6"
                          width="6"
                          height="2"
                          rx="1"
                          fill="#fff"
                        ></rect>
                      </g>
                    </svg>
                  </div>
                </div>

                <div className="table_cont statistics_table">
                  {statistics.map((item, index) => (
                    <div className="table_row" key={index}>
                      <div className="table_row_itm statistic_num">
                        <span className="ben_his_itm">{item.number}</span>
                      </div>

                      <div className="table_row_itm statistic_line">
                        <div
                          className="statistic_line_bg"
                          style={{
                            width: `${item.count + 10}%`,
                          }}
                        ></div>
                      </div>

                      <div className="table_row_itm statistic_val">
                        {item.count}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* FOOTER */}
        <div className="game_footer">
          <h1 className="fairness2" id="trs_fairness1">
            Leo Games
          </h1>
        </div>
      </div>
    </div>
  );
};

export default KenoRightSidebar;
